import { useState, useEffect } from 'react';
// Hook
const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: false,
        isTablet: false,
        isTabletMini: false,
        isPortrait: window.innerHeight > window.innerWidth,
    });

    useEffect(() => {
        const handleOnResize = () => {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
                isMobile: window.innerWidth < 500 || window.innerHeight < 426 && window.innerWidth < 640 || window.innerHeight < 640 && window.innerWidth < 550,
                isTablet: window.innerWidth > 500 && window.innerWidth < 921,
                isTabletMini: window.innerWidth < 600 && window.innerWidth > 425 && window.innerHeight < 916,
                isPortrait: window.innerHeight > window.innerWidth,
            });
        }

        // isPortrait: (window.innerHeight < window.innerWidth)

        // Add event listener
        window.addEventListener("resize", handleOnResize);

        // Call handler right away so state gets updated with initial window size
        handleOnResize();

        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleOnResize);
    }, []); // Empty array ensures that effect is only run on mount

    return windowSize;
}

export default useWindowSize;
